import { Router, ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { tap } from 'rxjs/operators';
import { Field, FieldDataType, ModuleStructure } from './../../../../models/module-structure';
import { TimeService } from './../time.service';
import { Component, OnInit, OnDestroy, Injector, Input, Output, EventEmitter } from '@angular/core';
import { Subscriber, Subscription } from 'rxjs';
import { ListPayload } from '../../models/ListPayload';
import { LayoutService } from 'src/app/layout/layout.service';
import { CodeNameModel } from 'src/app/models/DropDownModels';
import { Dictionary } from 'src/app/apps/shoppingCart/interfaces/shoppingCartQueue';

@Component({
  selector: 'app-base-component',
  templateUrl: './base-component.component.html',
  styleUrls: ['./base-component.component.less']
})
export class BaseTimeComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() showSider = true;
  subs: Subscription[] = [];
  payload: ListPayload = {
    PageSize: 10,
    PageIndex: 0,
    OrderByField: 'Id',
    IsAsc: false,
    Conditions: []
  };
  filterableFields: Field[] = [];
  siderFields: Field[] = [];
  totalRecords = 0;
  records: any[] = [];
  filterObject: any = {};
  isCollapsed = false;
  selectMetaData: Dictionary<string, CodeNameModel[]>[] = [];
  moduleStructure: ModuleStructure;
  protected timeService: TimeService;
  protected layoutService: LayoutService;
  protected notificationService: NzNotificationService
  protected router: Router
  protected route: ActivatedRoute
  constructor(injector: Injector) {
    this.timeService = injector.get(TimeService);
    this.layoutService = injector.get(LayoutService);
    this.notificationService = injector.get(NzNotificationService);
    this.router = injector.get(Router);
    this.route = injector.get(ActivatedRoute);
  }
  ngOnInit() {
    this.layoutService.containerTransparentBGEmitter.emit(true);
    console.log('BaseTimeComponent ngOnInit');

  }
  ngOnDestroy(): void {
    console.log('BaseTimeComponent ngOnDestroy');

    this.subs.forEach(sub => sub.unsubscribe());
    this.layoutService.containerTransparentBGEmitter.emit(false);
  }
  filter() {
    Object.keys(this.filterObject).forEach(key => {
      if (this.filterObject[key] === '' || this.filterObject[key] == null) {
        delete this.filterObject[key];
        this.payload.Conditions = this.payload.Conditions.filter(condition => condition.Key != key);
      }
      else {
        const field = this.filterableFields.find(x => x.FieldName == key);
        let value;
        if (field.DataType == FieldDataType.Time) {
          const date = LayoutService.HardCopyObject(this.filterObject[key]) as Date;
          const time = date.toTimeString().split(':');
          // const temp = this.filterObject[key].toString().split('T')[1].split(':');
          value = `${time[0]}${time[1]}`;
        }
        else {
          value = this.filterObject[key];
        }
        const oldFilter = this.payload.Conditions.find(x => x.Key == key);
        if (oldFilter) {
          oldFilter.Value = value;
        }
        else {
          this.payload.Conditions.push({
            Key: field.FieldName,
            Value: value,
            Type: field.DataType
          });
        }
      }
    })
  }
}

